export default "__VITE_ASSET__DU0IhZ0R__"